import { TypedUseSelectorHook, useSelector } from 'react-redux';
import { IState } from '../../ducks';

export const useMiaSelector: TypedUseSelectorHook<IState> = useSelector;
